import { gisColors } from "@modernary/mui/components/gis";
import { type ViewerDatasetGroup } from "@modernary/mui/components/viewer";

// Example of sharing viewer config within an app.
export const group1: ViewerDatasetGroup = { colors: gisColors[0] };
export const group2: ViewerDatasetGroup = { colors: gisColors[1] };
export const group3: ViewerDatasetGroup = { colors: gisColors[2] };
export const group4: ViewerDatasetGroup = { colors: gisColors[3] };
export const group5: ViewerDatasetGroup = { colors: gisColors[4] };
export const group6: ViewerDatasetGroup = { colors: gisColors[5] };
export const group7: ViewerDatasetGroup = { colors: gisColors[6] };
export const group8: ViewerDatasetGroup = { colors: gisColors[7] };
export const group9: ViewerDatasetGroup = { colors: gisColors[8] };

export const metadataContext = {
  1: { isIncluded: true, group: group1 },
  2: { isIncluded: true, group: group2 },
  3: { isIncluded: true, group: group3 },
  4: { isIncluded: true, group: group4 },
  5: { isIncluded: true, group: group5 },
  6: { isIncluded: true, group: group6 },
  7: { isIncluded: true, group: group7 },
  8: { isIncluded: true, group: group8 },
  9: { isIncluded: true, group: group9 },
};

export const additionalMetadata = [
  // Example -
  //   {
  //     id: 5,
  //     entity: "entityFive",
  //     sourceSystem: "sourceFive",
  //     subCategory: "subCatFive",
  //     label: "Air Pollution Sources",
  //     description: "example desc. 5",
  //   },
];
